import React from "react";

class SearchBar extends React.Component {
  state = { userInput: "", clickNum: 0 };
  /**
   **  onInputChange(event) {
   **    console.log(event.target.value);
   **  }
   ** onInputClick(event) {
   **   console.log(event.target.value);
   **   console.log("i got fucking clicked man");
   ** }*/
  //* we can define the callback methods like above, or in  case of one liners we can just use arrow functions instead.
  onFormSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.userInput);
  };
  render() {
    return (
      <div className="ui segment">
        <form className="ui form" onSubmit={this.onFormSubmit}>
          <div className="field">
            <label htmlFor="searchInput">Search Something!</label>
            <input
              placeholder="Anything! (almost)"
              className="image__input"
              id="searchInput"
              type="text"
              value={this.state.userInput}
              //! example of a one liner arrow callback function instead of using one in class
              onClick={(e) =>
                this.setState({
                  clickNum: "true",
                })
              }
              onChange={(e) =>
                this.setState({ userInput: e.target.value.toUpperCase() })
              }
            />
          </div>
          <div>{this.state.userInput}</div>
        </form>
      </div>
    );
  }
}

export default SearchBar;
